import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../Link'
import styled from 'styled-components'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'

const FooterContainer = styled.div`
  background-color: #000;
  height: auto;
  max-width: 100vw;
  align-items: center;
  color: #fff;
  padding: 60px;

  @media (max-width: 1024px) {
    padding: 30px;
  }

  @media (max-width: 1024px) {
    padding: 28px;
  }
`
const Footer = (props) => {
  const {
    logo,
    nyseLogo,
    nyseLink,
    copyrightText,
    sections,
    mobileButtons,
    privacyPolicyText,
    privacyPolicyUrl,
    siteTermsText,
    siteTermsUrl,
    basedInText,
  } = props.data
  const { locale } = props

  return (
    <div>
      <GradientBorder height="5px" />
      <FooterContainer>
        <>
          <div className={styles.footerGrid}>
            <div className={`${styles.column} ${styles.logoSection}`}>
              <Link
                to={locale === 'en-us' ? '/' : `/${locale}/`}
                className={styles.logoLink}
              >
                <GatsbyImage
                  image={logo.gatsbyImageData}
                  className={styles.logo}
                  alt={logo?.description}
                />
              </Link>
              <div className={styles.copyrightText}>{copyrightText}</div>
              <div className={styles.termsAndPrivacy}>
                <div>
                  <Link to={privacyPolicyUrl}>
                    <span>{privacyPolicyText}</span>
                  </Link>
                </div>
                <div>
                  <Link to={siteTermsUrl}>
                    <span>{siteTermsText}</span>
                  </Link>
                </div>
                <div>{basedInText}</div>
              </div>
            </div>

            {sections.map((section, idx) => (
              <div className={`${styles.column}`} key={idx}>
                <div className={styles.link}>
                  <Link to={section.url + '/'}>{section.label}</Link>
                  <div className={styles.sublinks}>
                    {section.sublinks.map((sublink, idx) => (
                      <Link to={sublink.url + '/'} key={idx}>
                        {sublink.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            ))}

            <div className={`${styles.column}`}>
              <div className={`${styles.logoContainer}`}>
                {nyseLink !== '#' ? (
                  <Link to={nyseLink}>
                    {nyseLogo.gatsbyImageData !== null ? (
                      <GatsbyImage
                        image={nyseLogo.gatsbyImageData}
                        alt="Ouster listed NYSE"
                      />
                    ) : (
                      <img src={nyseLogo.file.url} alt="Ouster listed NYSE" />
                    )}
                  </Link>
                ) : nyseLogo.gatsbyImageData !== null ? (
                  <GatsbyImage
                    image={nyseLogo.gatsbyImageData}
                    alt={nyseLogo?.description || ''}
                  />
                ) : (
                  <img
                    src={nyseLogo.file.url}
                    alt={nyseLogo?.description || ''}
                  />
                )}
              </div>
            </div>
          </div>

          <div className={styles.mobileButtonContainer}>
            {mobileButtons.map((mobileLink, idx) => (
              <Link to={mobileLink.url + '/'} key={idx}>
                {mobileLink.label}
              </Link>
            ))}
          </div>

          <div className={`${styles.mobileLogoSection}`}>
            <div className={styles.mobileOuterLogoContainer}>
              <div className={styles.mobileLogoContainer}>
                <Link
                  to={locale === 'en-us' ? '/' : `/${locale}/`}
                  className={styles.logoLink}
                >
                  <GatsbyImage
                    image={logo.gatsbyImageData}
                    className={styles.logo}
                    alt={logo?.description}
                  />
                </Link>
                <div className={styles.copyrightText}>{copyrightText}</div>
              </div>
              <div className={styles.mobileRightLogoContainer}>
                {nyseLink !== '#' ? (
                  <Link to={nyseLink}>
                    {nyseLogo.gatsbyImageData !== null ? (
                      <GatsbyImage
                        image={nyseLogo.gatsbyImageData}
                        alt="Ouster listed NYSE"
                      />
                    ) : (
                      <img src={nyseLogo.file.url} alt="Ouster listed NYSE" />
                    )}
                  </Link>
                ) : nyseLogo.gatsbyImageData !== null ? (
                  <GatsbyImage
                    image={nyseLogo.gatsbyImageData}
                    alt={nyseLogo?.description || ''}
                  />
                ) : (
                  <img
                    src={nyseLogo.file.url}
                    alt={nyseLogo?.description || ''}
                  />
                )}
              </div>
            </div>
            <div className={styles.termsAndPrivacy}>
              <div>
                <Link to={privacyPolicyUrl}>
                  <span>{privacyPolicyText}</span>
                </Link>
              </div>
              <div>
                <Link to={siteTermsUrl}>
                  <span>{siteTermsText}</span>
                </Link>
              </div>
              <div>{basedInText}</div>
            </div>
          </div>
        </>
      </FooterContainer>
    </div>
  )
}

export default Footer
